import React from 'react'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { AlertIcon } from 'transfix-icons'
import { TableHead, TableCell, TableRow } from 'transfix-ui'

interface IHistoricalQuotesTableHeaderProps {
  focusedQuoteId: string | null
}

const useStyles = makeStyles(() => ({
  iconParent: {
    display: 'flex',
    alignItems: 'center',
  },
  icons: {
    marginTop: '5px',
    marginLeft: '3px',
  },
}))

export const HistoricalQuotesTableHeader = ({
  focusedQuoteId,
}: IHistoricalQuotesTableHeaderProps) => {
  const sqtObjectiveFourEnabled = useFeatureFlag('sqtObjectiveFour')
  const equipmentColumnText = sqtObjectiveFourEnabled ? 'Equipment/Drop Type' : 'Equipment'
  const classes = useStyles()

  return (
    <TableHead>
      {focusedQuoteId === null ? (
        <TableRow>
          <TableCell>
            <div className={classes.iconParent}>
              Quote Created{' '}
              <Tooltip
                trigger={
                  <span className={classes.icons}>
                    <AlertIcon />
                  </span>
                }>
                The date Transfix created a price request record
              </Tooltip>
            </div>
          </TableCell>
          <TableCell>
            <div className={classes.iconParent}>
              Price Request ID{' '}
              <Tooltip
                trigger={
                  <span className={classes.icons}>
                    <AlertIcon />
                  </span>
                }>
                The ID Transfix assigns to a price request record. Multiple price request IDs can
                exist per shipment.
              </Tooltip>
            </div>
          </TableCell>
          <TableCell>Shipper</TableCell>
          <TableCell>
            <div className={classes.iconParent}>
              Shipment ID (Ext.){' '}
              <Tooltip
                trigger={
                  <span className={classes.icons}>
                    <AlertIcon />
                  </span>
                }>
                An ID a Shipper assigns to a shipment that a price request record was created for.
                If a shipper does not provide the ID, then Transfix assigns one.
              </Tooltip>
            </div>
          </TableCell>
          <TableCell>{equipmentColumnText}</TableCell>
          <TableCell>Pickup Location</TableCell>
          <TableCell>Delivery Location</TableCell>
          <TableCell>
            <div className={classes.iconParent}>
              Submitted Quote
              <Tooltip
                trigger={
                  <span className={classes.icons}>
                    <AlertIcon />
                  </span>
                }>
                The most recently offered rate recorded.
              </Tooltip>
            </div>
          </TableCell>
          <TableCell>
            <div className={classes.iconParent}>
              Bid Status
              <Tooltip
                position='left'
                trigger={
                  <span className={classes.icons}>
                    <AlertIcon />
                  </span>
                }>
                A shipment is &rsquo;won&rsquo; if a matching spot shipment was tendered to
                Transfix.
              </Tooltip>
            </div>
          </TableCell>
          <TableCell>
            <></>
          </TableCell>
        </TableRow>
      ) : (
        <TableRow>
          <TableCell>
            <></>
          </TableCell>
          <TableCell>Shipper</TableCell>
          <TableCell>Pickup Location</TableCell>
          <TableCell>Delivery Location</TableCell>
        </TableRow>
      )}
    </TableHead>
  )
}
